<template>
  <v-main class="profile_section">
      <v-container class="grid" v-if="visitedRestaurants.length !== 0">
        <RestaurantVisitCard v-for="restaurant in visitedRestaurants"
                             :key="restaurant.id"
                             :restaurant="restaurant"
                             :user-token="userToken"
                             :get-restaurant-visits="onGetRestaurantVisits"/>
      </v-container>

      <div v-else class="link">
        No visited restaurant yet. Check the
        <router-link to="/">Home</router-link>
        page.
      </div>
  </v-main>
</template>

<script>
import RestaurantVisitCard from "@/components/Visits/RestaurantVisitCard";


export default {
  name: "UserVisits",
  components: {
    RestaurantVisitCard,
  },

  data: () => ({}),
  computed: {},
  props: ['visitedRestaurants', 'onGetRestaurantVisits', 'userToken'],

  methods: {},

  created() {
  }
}
</script>

<style scoped>
.profile_section {
  -webkit-box-shadow: 0 0 10px grey;
  box-shadow: 0 0 10px grey;
  padding: 3vh;
  margin: 2vh;
  border-radius: 6px;
  width: 90vw;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 24%);
  grid-gap: 15px;
}

@media screen and (max-width: 1024px) {
  .grid {
    grid-template-columns: repeat(3, 33%);
  }
}

@media screen and (max-width: 768px) {
  .grid {
    grid-template-columns: repeat(2, 49%);
  }
}

@media screen and (max-width: 480px) {
  .grid {
    grid-template-columns: 100%;
  }
}
</style>
